import { sortCallData } from './json_helper'

export function formatData(dataSource, data) {
  switch(dataSource) {
    default:
    case "CALLS":
      return formatCallData(data);
    case "SUMMARY":
      return data;
  }
}

function formatCallData(data) {
  let calls = [];
  if (!data) {
    return calls;
  }

  let arr = data;

  if (data.records) {
    arr = data.records;
  }

  if (arr.length === 0) {
    return calls;
  }

  let embedded = arr[0].hasOwnProperty("data");

  arr.forEach(element => {
    let datum = element;
    if (embedded) {
      datum = element.data;
    }
    if (datum.hasOwnProperty("deployment")) {
      if (datum.deployment.includes("prod")) {
        calls.push(datum);
      }
    }
  });

  return sortCallData(calls);
}

export function getFormattedTime(ms) {
  let s = Math.round(ms/1000);
  if (s < 60) {
    return ["" + s,"Seconds"];
  }
  let m = Math.floor(s/60);
  s = s % 60;
  if (m < 60) {
    return [m + ":" + pad(s),"mm:ss"]
  }
  let h = Math.floor(m/60);
  m = m % 60;
  return [h + ":" + pad(m) + ":" + pad(s),"hh:mm:ss"];
}

function pad(t) {
  if (t < 10) {
    return "0" + t;
  }
  return "" + t;
}
